// Context exports - Primary export for auth functionality
// Force rebuild - 2025-08-04
export { AuthContext, AuthProvider, useAuth } from './contexts/AuthContext';
// Session context exports - Session management functionality moved to entities/auth
// Use @edusense/entities-auth to import SessionContext, SessionProvider, useSession directly
// Removing circular dependency: shared/auth-core should not import from entities/auth
// Type exports
export * from './types';
// Handler exports
export * from './handlers';
// Token management
export { TokenManager, tokenManager } from './token-manager';
// Utility exports
export { generateCodeVerifier, generateCodeChallenge } from './utils/pkce';
export { createDPoPHeaders, createDPoPProof, isDPoPSupported, generateDPoPKeyPair, exportPublicKeyAsJWK } from './utils/dpop';
export { isVSCodeEnvironment, getPathPrefix, getRoutePath } from './utils/navigation';
export { getEnvValue } from './utils/env';
export { handleRefreshTokenFlow } from './utils/refresh';
export { handleSilentRefreshPKCE } from './utils/silent-refresh';
export { initiateOAuth2Flow, loginWithRedirect, generateOAuthState, buildAuthorizationUrl, DEFAULT_OAUTH2_CONFIG } from './utils/oauth2';
// Auto-redirect utilities
export { handleAutoRedirect, shouldPerformAutoRedirect } from './utils/auto-redirect';
// Enhanced initialization with auto-redirect
export { initializeWithAutoRedirect, createEnhancedWebAuthHandler } from './utils/enhanced-init';
// Provider exports for specific environments  
export { SimpleAuthProvider as VsCodeAuthProvider, useSimpleAuth } from './providers/VsCodeAuthProvider';
// WebAuthProvider는 잘못된 OAuth2 플로우를 사용하므로 임시 비활성화 
// TODO: OAuth2 authorization code flow로 재구현 필요
// export { ApiAuthProvider as WebAuthProvider, useApiAuth } from './providers/WebAuthProvider';
// Token exchange utilities
export { exchangeAuthorizationCode, exchangeTokenAndFetchUserInfo } from './utils/tokenExchange';
// OAuth2 callback component
export { default as OAuth2CallbackPage } from './components/OAuth2CallbackPage';
export { useOAuth2Callback } from './hooks/useOAuth2Callback';
// Axios integration for API clients
export { createAuthAxiosInstance, createOrvalCustomInstance } from './axios/auth-axios-instance';
// Logout utilities - Spring Authorization Server standard OIDC RP-Initiated Logout
export { performWebLogout, createLogoutHandler } from './contexts/logout-utils';
// Token validation utilities
export { isValidIdToken, getValidIdToken } from './contexts/token-validation-utils';
// Auth state cleanup utilities
export { performFullCleanup, performMinimalCleanup } from './contexts/cleanup-utils';
// OIDC logout utilities 
export { createOidcLogoutUrl, performOidcLogout, validateLogoutState } from './contexts/oidc-logout-utils';
// 🚀 공통 OAuth 로그인 함수 - 모든 앱에서 사용
export { startOAuthLogin, handleSharedOAuthLogin, useSharedOAuthLogin, // 기존 호환성 유지
startGeminiLogin, handleSharedGeminiLogin, useSharedLogin, APP_CONFIGS } from './utils/shared-login';
// 🎯 플랫폼 감지 유틸리티 - 별도 패키지로 이동
// @edusense/shared-platform-detection 패키지를 직접 사용하세요
// 디버깅을 위한 전역 함수 추가
if (typeof window !== 'undefined') {
    // @ts-ignore
    window.debugTokenStatus = function() {
        import('./token-manager').then(function(param) {
            var tokenManager = param.tokenManager;
            tokenManager.debugTokenStatus();
        });
    };
}
